import React from "react";
import { interpolate, useCurrentFrame } from "remotion";

export interface ShimmerTextProps {
  children: React.ReactNode;
  baseColor?: string;
  shimmerColor?: string;
  intervalFrames?: number;
  style?: React.CSSProperties;
}

/**
 * ShimmerText Component
 * Efek teks berkilau (light sweep) yang bergerak halus melintasi teks.
 */
export const ShimmerText: React.FC<ShimmerTextProps> = ({
  children,
  baseColor = "#ffffff",
  shimmerColor = "#e8f36e",
  intervalFrames = 60,
  style,
}) => {
  const frame = useCurrentFrame();

  const cycle = frame % intervalFrames;
  const progress = interpolate(cycle, [0, intervalFrames], [-100, 200], {
    extrapolateRight: "clamp",
  });

  return (
    <span
      style={{
        display: "inline-block",
        position: "relative",
        backgroundImage: `linear-gradient(110deg, ${baseColor} 30%, ${shimmerColor} 50%, ${baseColor} 70%)`,
        backgroundSize: "200% 100%",
        backgroundPosition: `${progress}% 0`,
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
        ...style,
      }}
    >
      {children}
    </span>
  );
};
